import {setLocale} from 'yup';

setLocale({
    mixed: {
        default: '${path} صحیح نیست',
        required: '${path} اجباری است',
    },
    string: {
        length: '${path} باید ${length} کاراکتر باشد',
        min: '${path} حداقل باید ${min} کاراکتر باشد',
        max: '${path} باید حداکثر ${max} کاراکتر باشد',
        matches: '${path} وارد شده معتبر نیست',
        email: '${path} وارد شده معتبر نیست',
        url: '${path} باید یک آدرس URL معتبر باشد',
        trim: '${path} must be a trimmed string',
        lowercase: '${path} must be a lowercase string',
        uppercase: '${path} must be a upper case string',
    },
});